import en from "./en";
import bn from "./bn";
import hi from "./hi";

import kioskEn from "./kiosk/kiosk-en";
import kioskBn from "./kiosk/kiosk-bn";
import kioskHi from "./kiosk/kiosk-hi";

import kitchenEn from "./kitchen/kitchen-en";
import kitchenBn from "./kitchen/kitchen-bn";
import kitchenHi from "./kitchen/kitchen-hi";

import kitchenDiningEn from "./kitchenCumDining/kitchen-dining-en";
import kitchenDiningBn from "./kitchenCumDining/kitchen-dining-bn";
import kitchenDiningHi from "./kitchenCumDining/kitchen-dining-hi";

export const translations = {
  en,
  bn,
  hi,
};

export const surveyTranslations = {
  en: {
    kiosk: kioskEn,
    kitchen: kitchenEn,
    "kitchen-cum-dining": kitchenDiningEn,
  },

  bn: {
    kiosk: kioskBn,
    kitchen: kitchenBn,
    "kitchen-cum-dining": kitchenDiningBn,
  },

  hi: {
    kiosk: kioskHi,
    kitchen: kitchenHi,
    "kitchen-cum-dining": kitchenDiningHi,
  },
};